export enum SQL_PROVIDER {
  BigQuery = 'bigquery',
  DataBricks = 'databricks',
  Snowflake = 'snowflake',
  Trino = 'trino',
  Redshift = 'redshift'
}

export enum FabricProviderType {
  Spark = 'Spark',
  SQL = 'SQL',
  Airflow = 'Airflow',
  DataQuality = 'Data Quality',
  Orchestration = 'Prophecy'
}

export enum ProjectSourceType {
  imported = 'imported',
  new = 'new'
}

// GraphQL-facing provider values, as `addProject`/`providerType` expect them. Distinct from
// SQL_PROVIDER / ORCHESTRATION_PROVIDER, whose values are the lowercase fabric-side spellings.
export enum Providers {
  Spark = 'spark',
  BigQuery = 'BigQuery',
  Databricks = 'Databricks',
  Snowflake = 'Snowflake',
  Trino = 'Trino',
  Redshift = 'Redshift',
  ProphecyManaged = 'ProphecyManaged'
}
